import { NavigationLink } from 'mm-ui-components/dist/src/base/components/navigation/header/primaryHeader/PrimaryHeader';

export interface SecondaryHeaderState {
  logo: {
    svgLarge: string;
    svgSmall: string;
    svgLargeViewBox: string;
    svgSmallViewBox: string;
    alt: string;
    href: string;
  } | null;
  links: NavigationLink[] | null;
  moreLinksText: string;
  pagePath: string;
}

export const secondaryHeaderReducer = (state: SecondaryHeaderState = {} as SecondaryHeaderState, action: { type: string }) => {
  switch (action.type) {
    default:
      return state;
  }
};
